angular.module('eStories.plans', [
    'eStories.billing.model'
])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.plans', {
                url: 'plans',
                views: {
                    'mainView@': {
                        controller: 'PlansCtrl as plansCtrl',
                        templateUrl: 'plans/plans.tmpl.html'
                    }
                }
            })
            .state('eStories.navbars.cancel', {
                url: 'cancel',
                views: {
                    'mainView@': {
                        controller: 'PlansCtrl as plansCtrl',
                        templateUrl: 'plans/plans.tmpl.html'
                    }
                }
            })
            .state('eStories.navbars.changePlan', {
                url: 'changePlan',
                views: {
                    'mainView@': {
                        controller: 'PlansCtrl as plansCtrl',
                        templateUrl: 'plans/plans.tmpl.html'
                    }
                }
            });
    }])

    .controller('PlansCtrl', [
        '$scope',
        'BillingModel',
        'AccountModel',
        'ModalsModel',
        '$location',
        'SeoModel',
        'LL',
        '$rootScope',
        'PromoModel',
        '$filter',
        '$state',
        'GA',
        'AffiliatesProgramModel',
        function ($scope, BillingModel, AccountModel, ModalsModel, $location, SeoModel, LL, $rootScope, PromoModel, $filter, $state, GA, AffiliatesProgramModel) {

            AccountModel.resetPlanPurchaseProperties();
            SeoModel.applyMetaTags($state.current.name);

            const plansCtrl = this;

            GA.trackPageView($location.path());

            BillingModel.getAllPlans(function (planMap) {
                plansCtrl.monthlyPlanList = planMap['MONTHLY'];
                plansCtrl.annualPlanList = planMap['ANNUAL'];
                safeApply($scope);
            });

            plansCtrl.getAnnualPlan = function (index) {
                if (!plansCtrl.annualPlanList) {
                    return null;
                }
                return plansCtrl.annualPlanList[index];
            };

            plansCtrl.getBooksPerMonthImage = function (plan) {
                var planNumOfCredits = BillingModel.getPlanNumOfCredits(plan);
                return "bookNumberOfCredits_" + planNumOfCredits;
            };

            plansCtrl.getMostPopularPlanClass = function (plan) {
                if (plan.name === "Plus") {
                    return "active"
                }

                return "";
            };

            plansCtrl.getSavingPercentage = function (monthlyPrice, annualPrice) {
                const monthlyPriceToYearly = monthlyPrice * 12;
                const difference = monthlyPriceToYearly - parseInt(annualPrice);
                return Math.round(difference / monthlyPriceToYearly * 100);
            };

            if ($rootScope.currentState === 'eStories.navbars.cancel') {
                ModalsModel.open("/plans/cancelPlanModal.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
            }

            plansCtrl.showCancelPlanModal = function () {
                LL.tagCancelSelectEvent(AccountModel.isTrialMember(), AccountModel.getPlan().description,
                    AccountModel.subscriptionDetails.subscription.plan.name);
                ModalsModel.open("/plans/cancelPlanModal.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
            };

            plansCtrl.getChosenPlanClass = function (plan) {
                if (!plan || !plansCtrl.chosenPlan) {
                    return null;
                }
                if (plan.planPricingId === plansCtrl.chosenPlan.planPricingId) {
                    return "active";
                }

                return null;
            };

            plansCtrl.getPriceCopy = function (plan) {
                return PromoModel.hasPlanPromo() && PromoModel.promoPackage.plansPagePriceCopy && plan.planId === PromoModel.promoPackage.planId ? $filter("currencyToSymbol")(plan.currency) + PromoModel.promoPackage.plansPagePriceCopy : $filter("currencyToSymbol")(plan.currency) + plansCtrl.getMonthlyPrice(plan.price);
            };

            plansCtrl.getDescriptionCopy = function (plan) {
                return PromoModel.hasPlanPromo() && PromoModel.promoPackage.plansPageDescriptionCopy && plan.planId === PromoModel.promoPackage.planId ? PromoModel.promoPackage.plansPageDescriptionCopy : $filter("currencyToSymbol")(plan.currency) + plan.price + ' Billed Annually';
            };

            plansCtrl.getSaleCopy = function (plan, monthlyPlan) {
                return PromoModel.hasPlanPromo() && PromoModel.promoPackage.plansPageSaleCopy && plan.planId === PromoModel.promoPackage.planId ? PromoModel.promoPackage.plansPageSaleCopy : 'SAVE ' + plansCtrl.getSavingPercentage(monthlyPlan.price, plan.price) + '%';
            };

            plansCtrl.getMonthlyPrice = function (annualPrice) {
                return (annualPrice / 12).toFixed(2);
            };

            plansCtrl.choosePlan = function (plan) {
                plansCtrl.chosenPlan = plan;
            };

            plansCtrl.isPlanMyCurrentPlan = function (plan) {
                if (!AccountModel.hasSubscription() || plan == null) {
                    return false;
                }
                return plan.planPricingId === AccountModel.subscriptionDetails.subscription.planId;
            };

            plansCtrl.getLargePlansOrSeparatorClass = function (monthlyPlan, annualPlan) {
                if (!AccountModel.hasSubscription()) {
                    return null;
                }

                if (plansCtrl.isPlanMyCurrentPlan(monthlyPlan) || plansCtrl.isPlanMyCurrentPlan(annualPlan)) {
                    return "currentPlan"
                }
                return null;
            };

            plansCtrl.getCurrentPlanClass = function (plan) {
                if (plansCtrl.isPlanMyCurrentPlan(plan)) {
                    return "currentPlan"
                }

                return null;
            };

            plansCtrl.getConfirmButtonDisabledClass = function (monthlyPlan, annualPlan) {
                if (plansCtrl.planConversionInProgress ||
                    !plansCtrl.chosenPlan || plansCtrl.isPlanMyCurrentPlan(plansCtrl.chosenPlan) ||
                    (monthlyPlan.planPricingId !== plansCtrl.chosenPlan.planPricingId &&
                        annualPlan.planPricingId !== plansCtrl.chosenPlan.planPricingId)) {
                    return "disabled";
                }

                return null;
            };

            plansCtrl.getPlanTabClass = function (family) {
                return plansCtrl.displayedPlanFamily === family ? 'active' : '';
            };

            plansCtrl.switchTab = function (family) {
                if (family == null) {
                    return;
                }
                plansCtrl.chosenPlan = null;
                plansCtrl.displayedPlanFamily = family;
                BillingModel.getAllPlans(function (planMap) {
                    plansCtrl.planList = planMap[family];
                    safeApply($scope);
                });
            };

            plansCtrl.getPlanDiscount = function (plan) {
                if (plan.family === "ANNUAL") {
                    switch (plan.name) {
                        case 'Basic':
                            return 17;
                        case 'Plus':
                            return 19;
                        case 'Premium':
                            return 20;
                    }
                }
                return null;
            };

            plansCtrl.displayErrorWithCode = function (message, code) {
                plansCtrl.updatePlanError = message;
                if (code) {
                    code = code.toLowerCase().replace(/_/g, " ").trim().replace(/(^[a-z])/g, function (a) {
                        return a.toUpperCase()
                    });
                    plansCtrl.updatePlanError += " (" + code + ")";
                }
                safeApply($scope);
            };

            plansCtrl.changePlanMap = [];
            plansCtrl.changePlanMap['Light'] = [];
            plansCtrl.changePlanMap['Light']['Light'] = 'none';
            plansCtrl.changePlanMap['Light']['Basic'] = 'upgrade';
            plansCtrl.changePlanMap['Light']['Plus'] = 'upgrade';
            plansCtrl.changePlanMap['Light']['Premium'] = 'upgrade';

            plansCtrl.changePlanMap['Basic'] = [];
            plansCtrl.changePlanMap['Basic']['Light'] = 'downgrade';
            plansCtrl.changePlanMap['Basic']['Basic'] = 'none';
            plansCtrl.changePlanMap['Basic']['Plus'] = 'upgrade';
            plansCtrl.changePlanMap['Basic']['Premium'] = 'upgrade';

            plansCtrl.changePlanMap['Plus'] = [];
            plansCtrl.changePlanMap['Plus']['Light'] = 'downgrade';
            plansCtrl.changePlanMap['Plus']['Basic'] = 'downgrade';
            plansCtrl.changePlanMap['Plus']['Plus'] = 'none';
            plansCtrl.changePlanMap['Plus']['Premium'] = 'upgrade';

            plansCtrl.changePlanMap['Premium'] = [];
            plansCtrl.changePlanMap['Premium']['Light'] = 'downgrade';
            plansCtrl.changePlanMap['Premium']['Basic'] = 'downgrade';
            plansCtrl.changePlanMap['Premium']['Plus'] = 'downgrade';
            plansCtrl.changePlanMap['Premium']['Premium'] = 'none';

            plansCtrl.submitChosenPlan = async () => {

                AccountModel.showUpdatePaymentDetailsModal();
                return;

                const chosenPlan = plansCtrl.chosenPlan;

                BillingModel.isPlanPurchase = true;
                if (!chosenPlan || plansCtrl.isPlanMyCurrentPlan(chosenPlan)) {
                    return;
                }

                const llObj = {
                    "Source": AffiliatesProgramModel.getUtmRequestObj() ? AffiliatesProgramModel.getUtmRequestObj().utmSource : null,
                    "OfferName": AccountModel.getSubscriptionName(chosenPlan)
                };

                LL.tagEvent('Selected Subscription Purchase', llObj);
                // If the user is subscribed
                if (AccountModel.hasSubscription()) {
                    if (plansCtrl.planConversionInProgress) {
                        return;
                    }
                    plansCtrl.planConversionInProgress = true;
                    const oldPlan = AccountModel.subscriptionDetails.subscription.plan.name;
                    const newPlan = chosenPlan.name;
                    const subscriptionId = AccountModel.subscriptionDetails.subscription.id;
                    // If the user has a promoPackage, make sure the promoPackage.planId matches the chosenPlan.id else, delete the promoPackage
                    if (PromoModel.promoPackage) {
                        if (PromoModel.promoPackage.planId !== chosenPlan.planId) {
                            PromoModel.clearPromoPackage();
                        } else {
                            AccountModel.setPendingPlanPurchaseType("PROMO");
                            return AccountModel.showUpdatePaymentDetailsModal();
                        }
                    }
                    // Here if user has a current plan WITHOUT a promo
                    try {
                        console.log('calling update Conversion plan', chosenPlan);
                        const response = await BillingModel.updateConversionPlan(
                            subscriptionId,
                            chosenPlan.planPricingId,
                            null);

                        if (response.responseStatus === "SUCCESS") {
                            const a = !plansCtrl.changePlanMap[oldPlan][newPlan] ?
                                'none' : plansCtrl.changePlanMap[oldPlan][newPlan];
                            LL.tagChangePlan(a, oldPlan, newPlan, false);
                            AccountModel.refreshSubscriptionDetails(() => {
                                $location.path("/browse");
                                PromoModel.promoPackage = null;
                                ModalsModel.open("/plans/postPlanPurchaseModal.tmpl.html",
                                    "PostPlanPurchaseCtrl",
                                    "postPlanPurchaseCtrl",
                                    "postPlanPurchaseModal");
                                plansCtrl.planConversionInProgress = false;
                            });
                        } else {
                            plansCtrl.displayErrorWithCode("Could not update plan", response.responseText);
                            plansCtrl.planConversionInProgress = false;
                        }
                    } catch (error) {
                        console.log("in heare", error);
                        plansCtrl.displayErrorWithCode("Could not update plan", error);
                    }
                } else {
                    // Sign up user to a subscription plan
                    AccountModel.setChosenPlan(chosenPlan);
                    // Not logged in
                    AccountModel.setPendingPlanPurchaseType("PLAN");
                    // If the user has a promoPackage, make sure the promoPackage.planId matches the chosenPlan.id else, delete the promoPackage
                    if (PromoModel.promoPackage) {
                        if (PromoModel.promoPackage.planId !== chosenPlan.planId) {
                            PromoModel.clearPromoPackage();
                        } else {
                            AccountModel.setPendingPlanPurchaseType("PROMO");
                        }
                    }
                    if (AccountModel.userDetails == null) {
                        AccountModel.showSignUp();
                    } else {
                        AccountModel.showUpdatePaymentDetailsModal();
                    }
                }
            };

            plansCtrl.getLargePlanErrorsClass = function () {
                if (plansCtrl.updatePlanError) {
                    return "active";
                }
                return null;
            };

            plansCtrl.switchTab("MONTHLY");


            plansCtrl.openMembershipHoldModal = function () {
                ModalsModel.open('/plans/membershipHold.tmpl.html', 'HoldCtrl', 'holdCtrl');
            };

            $scope.$on('showMembershipHoldConfirmationModal', function () {
                ModalsModel.open('/plans/membershipHoldConfirm.tmpl.html', 'HoldCtrl', 'holdCtrl');
            });

        }
    ])

    .controller('PostPlanPurchaseCtrl', [
        'AccountModel',
        '$uibModalInstance',
        function (AccountModel, $uibModalInstance) {
            var postPlanPurchaseCtrl = this;

            postPlanPurchaseCtrl.conversionPlanFamily = AccountModel.getConversionPlan().family.toLowerCase();

            postPlanPurchaseCtrl.closePostPlanPurchaseModal = function () {
                $uibModalInstance.close();
            };

        }])

    .controller('PostPlanSignUpCtrl', [
        'AccountModel',
        '$uibModalInstance',
        'AffiliatesProgramModel',

        function (AccountModel, $uibModalInstance, AffiliatesProgramModel) {
            var postPlanSignUpCtrl = this;

            postPlanSignUpCtrl.closePostPlanPurchaseModal = function () {
                $uibModalInstance.close();
            };

            postPlanSignUpCtrl.closePostBoosterPurchaseModal = function () {
                $uibModalInstance.close();
            };

            postPlanSignUpCtrl.getAffiliatePixel = function () {
                return AffiliatesProgramModel.getAffiliatePixel();
            };
        }])

    .controller('CancelPlanCtrl', [
        '$scope',
        'AccountModel',
        '$uibModalInstance',
        'ModalsModel',
        'BillingModel',
        '$location',
        'LL',
        'GA',
        function ($scope, AccountModel, $uibModalInstance, ModalsModel, BillingModel, $location, LL, GA) {
            var cancelPlanCtrl = this;

            cancelPlanCtrl.account = AccountModel;

            var cancelReasonDescriptionMap = {};
            cancelReasonDescriptionMap['technicalProblem'] = "I have a technical problem";
            cancelReasonDescriptionMap['cantFindEnough'] = "I can't find enough books I want to buy";
            cancelReasonDescriptionMap['anotherService'] = "I am going to try another service";
            cancelReasonDescriptionMap['dontUse'] = "I don't use it enough";
            cancelReasonDescriptionMap['resubscribeLater'] = "I plan to resubscribe later";
            cancelReasonDescriptionMap['tooMuchMoney'] = "I like it but it's more than I want to pay";
            cancelPlanCtrl.cancelReasonDescriptionMap = cancelReasonDescriptionMap;

            cancelPlanCtrl.displayErrorWithCode = function (message, code) {
                cancelPlanCtrl.updatePlanError = message;
                if (code) {
                    code = code.toLowerCase().replace(/_/g, " ").trim().replace(/(^[a-z])/g, function (a) {
                        return a.toUpperCase()
                    });
                    cancelPlanCtrl.updatePlanError += " (" + code + ")";
                }
                safeApply($scope);
            };

            cancelPlanCtrl.closeCancelPlanModal = function () {
                $uibModalInstance.close();
            };
            cancelPlanCtrl.getNextCreditRenewalDate = function () {
                return AccountModel.getNextCreditRenewalDate();
            };

            cancelPlanCtrl.technicalProblemFormModal = function () {
                ModalsModel.open("/plans/technicalProblemForm.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
            };

            cancelPlanCtrl.changePlan = async function () {
                var subscriptionId = AccountModel.subscriptionDetails.subscription.id;
                var oldPlan = AccountModel.subscriptionDetails.subscription.plan.name;
                try {
                    const response = await BillingModel.updateConversionPlan(subscriptionId, cancelPlanCtrl.newSavePlanPricingId, AccountModel.cancelReasonDescription);
                    if (response.responseStatus === "SUCCESS") {
                        LL.tagChangePlan('downgrade', oldPlan, cancelPlanCtrl.newSavePlanPricingId, true);
                        cancelPlanCtrl.closeCancelPlanModal();
                        AccountModel.refreshSubscriptionDetails(function () {
                            $location.path("/browse");
                            ModalsModel.open("/plans/postPlanPurchaseModal.tmpl.html", "PostPlanPurchaseCtrl", "postPlanPurchaseCtrl", "postPlanPurchaseModal");
                        });
                        return;
                    }
                    cancelPlanCtrl.displayErrorWithCode("Could not update plan", response.responseText);
                } catch (error) {
                    cancelPlanCtrl.displayErrorWithCode("Could not update plan", error);
                }
            };

            cancelPlanCtrl.continueToCancel = function () {
                cancelPlanCtrl.closeCancelPlanModal();
                ModalsModel.open("/plans/wereSorryToSeeYouGo.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
            };

            cancelPlanCtrl.cancelSavePlanSelected = false;

            cancelPlanCtrl.isTrialMember = function () {
                return AccountModel.isTrialMember();
            };

            cancelPlanCtrl.lowerPlansOfferModal = function () {
                cancelPlanCtrl.closeCancelPlanModal();
                var planFamily = AccountModel.subscriptionDetails.subscription.plan.family;
                var isTrial = AccountModel.subscriptionDetails.subscription.trial;
                var planName = AccountModel.subscriptionDetails.subscription.plan.name;
                if (!isTrial) {
                    switch (planFamily + "|" + planName) {
//                      monthly basic subscribers offered ONLY quarterly lite plan
                        case 'MONTHLY|Basic':
                            ModalsModel.open("/plans/savePlanOffers/quarterLiteOfferPlan.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
                            break;
//                      quarterly lite plan subscribers offered nothing
                        case 'QUARTERLY|Light':
                            ModalsModel.open("/plans/noOffer.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
                            break;
//                      monthly plus subscribers offered monthly basic and quarterly lite plans
                        case 'MONTHLY|Plus':
                            ModalsModel.open("/plans/savePlanOffers/monthBasicAndQuarterLiteOfferPlans.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
                            break;
//                      monthly plus subscribers offered monthly basic and monthly plus plans
                        case 'MONTHLY|Premium':
                            ModalsModel.open("/plans/savePlanOffers/monthBasicAndMonthPlusOfferPlans.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
                            break;
                        default:
                            ModalsModel.open("/plans/noOffer.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
                            break;
                    }
                } else if (isTrial) {
//                  trial subscribers offered nothing
                    ModalsModel.open("/plans/savePlanOffers/quarterLiteOfferPlan.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
                } else if (planFamily === "ANNUAL") {
//                  annual subscribers offered nothing
                    ModalsModel.open("/plans/noOffer.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
                } else {
                    ModalsModel.open("/plans/noOffer.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
                }
            };
            cancelPlanCtrl.accountHeldWithinLast12Months = function () {
                return AccountModel.shouldShowHoldMembershipOption();
            };

            cancelPlanCtrl.reasonSelected = false;

            cancelPlanCtrl.closeResubscribeModal = function () {
                $uibModalInstance.close();
            };

            cancelPlanCtrl.continueCancellation = function () {
                if (cancelPlanCtrl.cancelReason != null) {
                    AccountModel.setCancelReasonDescription(cancelReasonDescriptionMap[cancelPlanCtrl.cancelReason]);
                    cancelPlanCtrl.accountHeldWithinLast12Months = AccountModel.shouldShowHoldMembershipOption();
                    switch (cancelPlanCtrl.cancelReason) {
                        case 'technicalProblem':
                            cancelPlanCtrl.closeCancelPlanModal();
                            cancelPlanCtrl.technicalProblemFormModal();
                            break;
                        case 'cantFindEnough':
                            cancelPlanCtrl.closeCancelPlanModal();
                            ModalsModel.open("/plans/howToFindMoreModal.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
                            break;
                        case 'anotherService':
                            cancelPlanCtrl.closeCancelPlanModal();
                            ModalsModel.open("/plans/useAnotherService.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
                            break;
                        case 'dontUse':
                            cancelPlanCtrl.closeCancelPlanModal();
                            if (AccountModel.isTrialMember()) {
                                ModalsModel.open("/plans/savePlanOffers/quarterLiteOfferPlan.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
                            } else if (!AccountModel.shouldShowHoldMembershipOption()) {
//                              gets here if user is currently on hold / has an unfreeze date - redirect them to to noOffer
                                ModalsModel.open("/plans/noOffer.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
                            } else {
                                ModalsModel.open("/plans/dontUse.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
                            }
                            break;
                        case 'resubscribeLater':
                            cancelPlanCtrl.closeCancelPlanModal();
                            if (AccountModel.isTrialMember()) {
                                ModalsModel.open("/plans/savePlanOffers/quarterLiteOfferPlan.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
                            } else if (!AccountModel.shouldShowHoldMembershipOption()) {
//                              gets here if user is currently on hold / has an unfreeze date - redirect them to to noOffer
                                ModalsModel.open("/plans/noOffer.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
                            } else {
                                ModalsModel.open("/plans/dontUse.tmpl.html", 'CancelPlanCtrl', 'cancelPlanCtrl');
                            }
                            break;
                        case 'tooMuchMoney':
                            cancelPlanCtrl.closeCancelPlanModal();
                            cancelPlanCtrl.lowerPlansOfferModal();
                            break;
                        default:
                            break;
                    }
                }
            };

            cancelPlanCtrl.confirmCancellation = async function () {
                cancelPlanCtrl.cancellationInProgress = true;
                var subscriptionId = AccountModel.subscriptionDetails.subscription.id;
                const response = await AccountModel.cancelSubscriptionLater(subscriptionId, null, AccountModel.cancelReasonDescription);
                if (response != null && response.responseStatus === 'SUCCESS') {
                    //continueCancellation
                    GA.trackEvent("Cancel", "Cancel Plan");
                    LL.tagCancelEvent(response, AccountModel.isTrialMember(), AccountModel.getPlan().description,
                        AccountModel.subscriptionDetails.subscription.cycleCount);
                    AccountModel.refreshSubscriptionDetails();
                    $uibModalInstance.close();
                    $location.path('/account');
                    ModalsModel.open('/plans/submitCancelPlanModal.tmpl.html', 'CancelPlanCtrl', 'cancelPlanCtrl');
                }
                cancelPlanCtrl.cancellationInProgress = false;
            };

            cancelPlanCtrl.openMembershipHoldModal = function () {
                ModalsModel.open('/plans/membershipHold.tmpl.html', 'HoldCtrl', 'holdCtrl');
            };

            cancelPlanCtrl.getErrorMessage = function (responseMessage) {
                switch (responseMessage) {
                    case 'CANNOT_CREATE_SUBSCRIPTION':
                        return "In order to reactivate your subscription, please contact our support team, who will be happy to help.";
                    default :
                        return "In order to reactivate your subscription, please contact our support team, who will be happy to help.";
                }
            };

            cancelPlanCtrl.clearCancelSubscribeLater = async function () {
                cancelPlanCtrl.reactivationInProgress = true;
                var subscriptionId = AccountModel.subscriptionDetails.subscription.id;
                const response = await AccountModel.clearCancelSubscriptionLater(subscriptionId);
                if (response != null && response.responseStatus === 'SUCCESS') {
                    AccountModel.refreshSubscriptionDetails();
                    $uibModalInstance.close();
                    cancelPlanCtrl.reactivationInProgress = false;
                    AccountModel.refreshUserDetails();
                } else {
                    cancelPlanCtrl.reactivationInProgress = false;
                    cancelPlanCtrl.reactivateError = cancelPlanCtrl.getErrorMessage(response.responseText);
                    // cancelPlanCtrl.reactivateError = response.responseText;
                }
            };

            BillingModel.getAllPlans(function (planMap) {
                cancelPlanCtrl.monthlyPlanList = planMap['MONTHLY'];
                cancelPlanCtrl.quarterlyPlanList = planMap['QUARTERLY'];
                safeApply($scope);
            });

            cancelPlanCtrl.getMonthlyPlan = function (index) {
                if (!cancelPlanCtrl.monthlyPlanList) {
                    return null;
                }
                return cancelPlanCtrl.monthlyPlanList[index];
            }

            cancelPlanCtrl.getQuarterlyPlan = function () {
                if (!cancelPlanCtrl.quarterlyPlanList) {
                    return null;
                }
                return cancelPlanCtrl.quarterlyPlanList[0];
            };
        }])

    .controller('HoldCtrl', [
        'AccountModel',
        '$uibModalInstance',
        '$rootScope',
        'LL',
        function (AccountModel, $uibModalInstance, $rootScope, LL) {

            var holdCtrl = this;

            holdCtrl.holdDuration = null;

            holdCtrl.closeMembershipHoldModal = function () {
                $uibModalInstance.close();
            };

            holdCtrl.tagLLEventHoldAccount = function (responseStatus) {
                var lltagObj = {};
                lltagObj['Current Plan'] = AccountModel.subscriptionDetails.subscription.plan.name;
                lltagObj['Current Plan Period'] = AccountModel.subscriptionDetails.subscription.plan.family;
                lltagObj['Hold Period'] = holdCtrl.holdDuration;
                lltagObj['Success'] = responseStatus === 'SUCCESS' ? 'yes' : 'no';
                LL.tagEvent('Hold Account', lltagObj)
            };

            holdCtrl.freezeMembership = async function () {
                holdCtrl.serverError = null;
                if (holdCtrl.holdDuration == null) {
                    holdCtrl.serverError =
                        'Please choose a hold duration.';
                    return;
                }
                holdCtrl.callInProgress = true;
                const response = await AccountModel.freezeMembership(holdCtrl.holdDuration);
                holdCtrl.tagLLEventHoldAccount(response.responseStatus);
                if (response && response.responseStatus === 'SUCCESS') {
                    AccountModel.refreshSubscriptionDetails(function () {
                        holdCtrl.callInProgress = false;
                        $uibModalInstance.close();
                        $rootScope.$broadcast('showMembershipHoldConfirmationModal');
                    });
                } else {
                    holdCtrl.callInProgress = false;
                    holdCtrl.serverError =
                        'You may only put your account on hold once per year,' +
                        ' starting from the first day you place your account on hold.'
                }

            }
        }]);

